// @flow
import './TimelineComment.css';

import * as React from 'react';
import classNames from 'classnames';
import { AnnotationThread } from '../autogenerated/ZoomBridge';

type Props = {
  comment: AnnotationThread,
  isInFocusedCluster: boolean,
  onCommentClick: Function,
  style: Object
};

export default class TimelineComment extends React.Component<Props, {}> {
  render() {
    const { comment, isInFocusedCluster, onCommentClick, style } = this.props;
    const index = comment.getAnnotationLocation().getCommentIndex();

    return (
      <div
        name="TimelineComment"
        className={classNames(comment.getAnnotationKind().toLowerCase(), { focus: isInFocusedCluster })}
        style={{ zIndex: index, ...style }}
        onClick={(e) => onCommentClick(e, comment)}
        data-threadid={comment.getThreadId()}>
        <div className="bubble">{index}</div>
        <div className="line" />
      </div>
    );
  }
}
